import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Switch } from '@coolblue-development/freddy';
import { useRouter } from 'next/navigation.js';
import { disableSplitTests } from '../../server/Tool/disableSplitTests.js';
const SplitTestsSettings = ({ isDisabled, setDisabled }) => {
    const router = useRouter();
    return (_jsx(_Fragment, { children: _jsx(Switch, { label: "Disable all split tests", defaultChecked: isDisabled, onChange: value => {
                disableSplitTests(value).then(() => {
                    setDisabled(value);
                    router.refresh();
                });
            } }) }));
};
export default SplitTestsSettings;
//# sourceMappingURL=SplitTestsSettings.js.map